import React, { useEffect, useState } from "react";
// import placeholder from "../assets/blog.png";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import API_BASE_URL from "../config";
export const Blogs = () => {
  const navigate = useNavigate();

  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/posts`)
      .then((res) => setPosts(res.data))
      .catch((err) => console.error("Error fetching blogs:", err));
  }, []);

  const handleReadMore = (id) => {
    console.log("Redirect post id " + id);
    navigate(`/blog/${id}`);
  };
  return (
    <>
      <section className="hero-section position-relative">
        <div className="hero-overlay"></div>
        <div className="container-fluid position-relative text-white px-5">
          <p className="text-left heading">
            Grow, Secure, <span style={{ color: "#76ABAE" }}>Invest</span>
          </p>
          <p className="content">
            Dive into expert tips, insights, and strategies to build a
            financially secure future.
          </p>
        </div>
      </section>

      <section className="container my-5">
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              {posts.map((post, index) => (
                <div className="col-md-6 mb-4" key={index}>
                  <div className="card blog-card h-100 bg-black rounded-4">
                    <img
                      src={`${post.imageUrl}`}
                      className="card-img-top"
                      style={{
                        height: "250px",
                        width: "100%",
                        objectFit: "cover",
                      }}
                      alt={post.title}
                    />

                    <div className="card-body">
                      <h5>{post.title}</h5>
                      <p className="small" style={{ color: "#76ABAE" }}>
                        {new Date(post.createdAt).toDateString()}
                      </p>
                      <p>{post.content.substring(0, 80)}...</p>
                      {/* <a
                        href={`${API_BASE_URL}/posts/${post._id}`}
                        className="btn btn-light rounded-pill px-4 btn-sm"
                      >
                        Read More →
                      </a> */}
                      {/* <Link
                        to={`/blog/${post._id}`}
                        className="btn btn-light rounded-pill px-4 btn-sm"
                      >
                        Read More →
                      </Link> */}
                      <button
                        onClick={() => handleReadMore(post._id)}
                        className="btn btn-light rounded-pill px-4 btn-sm"
                      >
                        Read More →
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>
    </>
  );
};
